import { c as _c } from "react/compiler-runtime";
import { logger } from "@justhome/common";
import ButtonId from "@lib/buttonId";
import { FATHOM_CLICK_EVENTS } from "@lib/constants";
import { isProd, isTest } from "@lib/settings";
import { getFromStorage, saveToStorage } from "@lib/utilities";
import { useRouter } from "@lib/hooks/useRouter";
import { useEffect } from "react";
import { fathom } from "@justhome/common";
declare global {
  interface Window {
    customReferrer?: string;
  }
}
const customReferrerTimeout = 60 * 1000 * 30;
const Fathom = () => {
  const $ = _c(8);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== router) {
    t0 = () => {
      if (!router.isReady) {
        return;
      }
      const {
        fathomEvent,
        ...query
      } = router.query;
      if (fathomEvent) {
        fathom.trackEvent(fathomEvent as string);
        router.replace({
          pathname: router.pathname,
          query
        });
      }
    };
    t1 = [router.isReady, router];
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(_temp2, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(_temp3, t3);
  let t4;
  let t5;
  if ($[5] !== router.events) {
    t4 = () => {
      const onRouteChangeComplete = function onRouteChangeComplete() {
        window.customReferrer = window.location.toString();
        saveToStorage("last-fathom-pageview", Date.now().toString());
        fathom.trackPageview();
      };
      const isEnabled = !isTest;
      if (isEnabled) {
        router.events.on("routeChangeComplete", onRouteChangeComplete);
      }
      return () => {
        if (isEnabled) {
          router.events.off("routeChangeComplete", onRouteChangeComplete);
        }
      };
    };
    t5 = [router.events];
    $[5] = router.events;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  return null;
};
export default Fathom;
function _temp(event) {
  const eventName = FATHOM_CLICK_EVENTS[(event.target as HTMLElement)?.id as ButtonId];
  if (eventName) {
    if (!isProd) {
      console.log("Fathom: tracking event", eventName);
    }
    fathom.trackEvent(eventName);
  }
}
function _temp2() {
  const handleClick = _temp;
  document.body.addEventListener("click", handleClick);
  return () => {
    document.body.removeEventListener("click", handleClick);
  };
}
function _temp3() {
  window.customReferrer = window.document.referrer;
  ;
  try {
    Object.defineProperty(window.document, "referrer", {
      get() {
        return window.customReferrer;
      }
    });
  } catch (t0) {
    const error = t0;
    logger.error(`Error in ${Fathom.name} component.`, error);
  }
  const lastFathomPageview = getFromStorage("last-fathom-pageview");
  if (lastFathomPageview) {
    const time = Number(lastFathomPageview);
    if (Date.now() - time < customReferrerTimeout) {
      window.customReferrer = window.location.toString();
    }
  }
}